import { BaseEntity } from "./BaseEntity";

export class Gesture extends BaseEntity {
    public name: string = "";

    constructor(model: Partial<Gesture> = {}) {
        super(model?.id);
        Object.assign(this, model);
    }
}

export type PGesture = Partial<Gesture>;
